<template>
    <div v-if="true">
        <div @click="$emit('close')" class="w-full h-[150%] fixed top-0 left-0 bg-[#00000063] z-40 backdrop-blur-[2px]">
        </div>
        <div class="flex fixed justify-center top-[20%] bottom-[20%]  left-[10%] right-[10%] items-center  z-40">
            <div class="flex flex-col justify-center  z-40 bg-white w-[500px] text-lg rounded-lg border-[2px] border-[#006A00] relative">
                <div class="pafcpic_header bg-[#12760A] py-3 px-6">
                    <p class="text-[#ffffff] text-md font-bold">Employment History</p>
                </div>
                <div class="pafcpic_body py-3 px-6">
                    <p class="text-xs text-[#868585] mb-1 ml-1 mt-2 font-medium">Select Office *</p>
                    <select class="border-[#ACA9A9] border rounded-md py-2 px-3 text-sm text-[#12760A] font-semibold w-full outline-none" v-model="employeetype">
                        <option value="" disabled>Select Office</option>
                        <option value="1">OUTSIDE COMPANY</option>
                        <option value="2">PAFCPIC</option>
                    </select>
                    <div v-if="employeetype == '2'">
                        <p class="text-xs text-[#868585] mb-1 ml-1 mt-2 font-medium">Division *</p>
                        <input type="text" class="border-[#ACA9A9] border rounded-md py-3 px-3 text-sm text-[#006A00] font-semibold w-full outline-none" placeholder="Division name" @input="division = division.toUpperCase()" v-model="division" >
                        <p class="text-xs text-[#868585] mb-1 ml-1 mt-2 font-medium">Department </p>
                        <input type="text" class="border-[#ACA9A9] border rounded-md py-3 px-3 text-sm text-[#006A00] font-semibold w-full outline-none" placeholder="Department name" @input="department = department.toUpperCase()"   v-model="department">
                        <p class="text-xs text-[#868585] mb-1 ml-1 mt-2 font-medium">Section</p>
                        <input type="text" class="border-[#ACA9A9] border rounded-md py-3 px-3 text-sm text-[#006A00] font-semibold w-full outline-none" placeholder="Section name" @input="section = section.toUpperCase()"  v-model="section">
                    </div>
                    <div v-if="employeetype == '1'">
                          <p class="text-xs text-[#868585] mb-1 ml-1 mt-2 font-medium">Company Name *</p>
                    <input type="text" class="border-[#ACA9A9] border rounded-md py-3 px-3 text-sm text-[#006A00] font-semibold w-full outline-none" placeholder="Company name"  @input="companyname = companyname.toUpperCase()" v-model="companyname" >
                    </div>
                    <p class="text-xs text-[#868585] mb-1 ml-1 mt-2 font-medium">Position *</p>
                    <input type="text" class="border-[#ACA9A9] border rounded-md py-3 px-3 text-sm text-[#006A00] font-semibold w-full outline-none" placeholder="Position name"  @input="position = position.toUpperCase()"   v-model="position">
                    <p class="text-xs text-[#868585] mb-1 ml-1 mt-2 font-medium">Start Date*</p>
                    <input type="date" class="border-[#ACA9A9] border rounded-md py-3 px-3 text-sm text-[#006A00] font-semibold w-full outline-none" placeholder="Middle Name"    v-model="startdate" >
                    <p class="text-xs text-[#868585] mb-1 ml-1 mt-2 font-medium">End Date*</p>
                    <input type="date" class="border-[#ACA9A9] border rounded-md py-3 px-3 text-sm text-[#006A00] font-semibold w-full outline-none"  placeholder="Relationship"  v-model="enddate" >
                </div>
                <div class="pafcpic_footer flex gap-4 justify-end px-5 py-3 border-[#00800048] border-t font-medium">
                    <button class="text-sm text-[#e7e5e5] bg-[#006A00] py-1.5 px-7 rounded-md w-[100px] text-center" :disabled="disabledbtn" v-on:click="addEmployemntHistory">Save</button>
                    <button class="text-sm text-[#6A6A6A] bg-[#D9D9D9] py-1.5 px-7 rounded-md w-[100px] text-center" v-on:click="$emit('close')">Cancel</button>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import { defineComponent } from 'vue';

export default defineComponent({

    data(){
        return{
            disabledbtn:false,
            employeetype: '1',
            division: '',
            department: '',
            section: '',
            companyname: '',
            position: '',
            startdate: '',
            enddate: '',
        }
    },
    mounted(){
    },
    methods:{
        async addEmployemntHistory(){
            if(this.employeetype == '1'){
                await this.$emit('outsideEmploytment',this.companyname,
                    this.position,
                    this.startdate,
                    this.enddate
                )
            }
            else{
                await this.$emit('insideEmploytment',this.division,
                    this.department,
                    this.section,
                    this.position,
                    this.startdate,
                    this.enddate
                )
            }
        }
    },

});

</script>